import { useState, useEffect } from 'react';
import Input from "components/FormComponents/Input/Input"
import Select from "components/FormComponents/Select/Select"
import { FormData, StorageSetupDatabase } from "lib/types"
import { InputTypes } from "../../../lib/enums"

const ServerSettingsStorageSetup = ({ formData, storageSetup, handleDataChange, header, children }: ServerSettingsStorageSetupProps) => {

    const headerForIds = header.replace(/\s+/g, '-').toLowerCase();

    const [maxMinDiskSizeValue, setMaxMinDiskSizeValue] = useState(storageSetup?.diskType === 3 ? 7 : 20)
    const [minDiskSizeValue, setMinDiskSizeValue] = useState(storageSetup?.diskSizeMin)
    const handleInputChange = (propertyName: string, initialValue?: number) => (value: number) => {

        if (!isNaN(value) && initialValue === value) {
            return
        }
        handleDataChange(propertyName, Number(value));

        //check and update the max min disk size for this storage setup
        setMaxMinDiskSize(propertyName, Number(value));
    }

    const setMaxMinDiskSize = (propertyName, value) => {
        if (propertyName === "diskType") {
            if (value === 3) {                
                setMaxMinDiskSizeValue(7);
                return;
            } 

            setMaxMinDiskSizeValue(20);
        }
    }

    useEffect(() => {
        if (storageSetup) {            
            if (storageSetup.diskType === 3 && storageSetup.diskSizeMin > 7) {
                setMinDiskSizeValue(7);
            }
            if (storageSetup.diskType === 1 && storageSetup.diskSizeMin > 20) {
                setMinDiskSizeValue(20);
            }

            setMinDiskSizeValue(storageSetup?.diskSizeMin);
        }
    }, [storageSetup]);

    return (
        <>
            <div className='row justify-content-start align-items-end ml-2'>
                <div className='server-settings__subheader msds-text-body-1 col-12 my-4'>{header}</div>
                {children}
                <Select
                    id={"xsd__e2e-" + headerForIds + "-storage-connectivity"}
                    className='col-3 mb-4 dropdownlist__storage-connectivity'
                    defaultOption={{ label: "Storage Connectivity", value: '' }}
                    options={formData?.storageConnectivities}
                    isSmall
                    handleDataChange={handleInputChange("storageConnectivity")}
                    initialValue={storageSetup?.storageConnectivity.toString()} />
                <Select
                    id={"xsd__e2e-" + headerForIds + "-raid-array"}
                    className='col-3 mb-4 dropdownlist__raid-array'
                    defaultOption={{ label: "Raid Array", value: '' }}
                    options={formData?.raidTypes}
                    isSmall
                    handleDataChange={handleInputChange("raidType")}
                    initialValue={storageSetup?.raidType.toString()} />
            </div>
            <div className='row justify-content-start align-items-end ml-2'>
                <Select
                    id={"xsd__e2e-" + headerForIds + "-disk-type"}
                    className='col-3 mb-4'
                    defaultOption={{ label: "Disk Type", value: '' }}
                    options={formData?.diskTypes}
                    isSmall
                    handleDataChange={handleInputChange("diskType")}
                    initialValue={storageSetup?.diskType.toString()} />
                <Input
                    id={"xsd__e2e-" + headerForIds + "-disk-size-min"}
                    type={InputTypes.Number}
                    className='col-3 mb-4'
                    label='Disk Size Min (TB)'
                    isSmall
                    handleDataChange={handleInputChange("diskSizeMin", storageSetup?.diskSizeMin)}
                    initialValue={minDiskSizeValue?.toString()}
                    maximumNumber={maxMinDiskSizeValue}
                    minimumNumber={0}
                />
                <Input
                    id={"xsd__e2e-" + headerForIds + "-disk-size-max"}
                    type={InputTypes.Number}
                    className='col-3 mb-4'
                    label='Disk Size Max (TB)'
                    isSmall
                    handleDataChange={handleInputChange("diskSizeMax", storageSetup?.diskSizeMax)}
                    initialValue={storageSetup?.diskSizeMax.toString()}
                    maximumNumber={999}
                    minimumNumber={0}
                />
            </div>
        </>
    )
}

export default ServerSettingsStorageSetup

type ServerSettingsStorageSetupProps = {
    formData: FormData;
    storageSetup: StorageSetupDatabase,
    handleDataChange: (propertyName: string, value: number) => void,
    header: string,
    children?: JSX.Element | JSX.Element[]
}